import { Editor, Transforms } from 'slate'
import { func, oneOf } from 'prop-types'
import { upperFirst } from 'lodash-es'
import { useSlateStatic } from 'slate-react'
import cc from 'classcat'

import { ALIGNABLE_TYPES } from '../serialization'

function countNodes(editor, format) {
  const nodes = Array.from(
    Editor.nodes(editor, { match: (n) => n.align === format && ALIGNABLE_TYPES.includes(n.type) }),
  )
  return nodes.length
}

export default function AlignButton({ t, format }) {
  const editor = useSlateStatic()

  const leftAligned = countNodes(editor, 'left') + countNodes(editor, undefined)
  const centerAligned = countNodes(editor, 'center')
  const rightAligned = countNodes(editor, 'right')

  const isActive = {
    left: leftAligned && !centerAligned && !rightAligned,
    center: centerAligned && !leftAligned && !rightAligned,
    right: rightAligned && !leftAligned && !centerAligned,
  }[format]

  function handleMouseDown(event) {
    event.preventDefault()

    if (isActive) Transforms.setNodes(editor, { align: undefined }, { match: (n) => ALIGNABLE_TYPES.includes(n.type) })
    else Transforms.setNodes(editor, { align: format }, { match: (n) => ALIGNABLE_TYPES.includes(n.type) })
  }

  return (
    <button
      className={cc([
        'dali-plugin-text-toolbar-button',
        `dali-plugin-text-toolbar-button-justify-${format}`,
        { active: isActive },
      ])}
      data-command-name={`justify-${format}`}
      type="button"
      title={t(`justify${upperFirst(format)}Button.tooltip`)}
      onMouseDown={handleMouseDown}
    />
  )
}

AlignButton.propTypes = { format: oneOf(['left', 'center', 'right']), t: func.isRequired }
